<template>
  <div class="card mb-25 border-0 rounded-0 bg-white profile-settings-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" v-if="user">
      <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
        <div class="row ">
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Full Name
              </label>
              <Field name="name" v-slot="{ field }" v-model="user.name">
                <input v-bind="field" type="text" class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. Jone Doe" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.name }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Username
              </label>
              <Field name="user_name" v-slot="{ field }" v-model="user.user_name">
                <input v-bind="field" type="text" readonly class="form-control shadow-none rounded-0 text-black bg-light"
                  placeholder="e.g. Smith" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.user_name }}</span>

            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Email Address
              </label>
              <Field name="email" v-slot="{ field }" v-model="user.email">
                <input v-bind="field" type="email" disabled class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. adam127704@gmail.com" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.email }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Address
              </label>
              <Field name="address" v-slot="{ field }" v-model="user.address">
                <input v-bind="field" type="text" class="form-control shadow-none rounded-0 text-black"
                  placeholder="Set your address here" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.address }}</span>

            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Country
              </label>
              <Field name="country" v-slot="{ field }" v-model="selectedCountry">

                <country-select v-bind="field" name="country" :country="selectedCountry" topCountry="US"
                  :countryName="true" class="text-xs bg-gray outline-none w-full border text-black select-border px-[20px]"
                  style="height: 44px;" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.country }}</span>


            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Region
              </label>
              <Field name="city" v-slot="{ field }" v-model="selectedRegion" >
                <region-select v-bind="field" name="city" :country="selectedCountry" :region="selectedRegion"
                  :countryName="true" :regionName="true"
                  class="text-xs bg-gray outline-none w-full border text-black select-border px-[20px]" style="height: 44px;" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.city }}</span>
            </div>
          </div>
          <div v-if="user.role === 'user'" class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Telegram
              </label>
              <Field name="tglink" v-slot="{ field }" v-model="user.tglink">
                <input v-bind="field" type="text" class="form-control shadow-none rounded-0 text-black"
                  placeholder="https://t.me/<user>" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.tglink }}</span>
            </div>
          </div>
          <div v-if="user.role === 'admin'" class="col-md-12">
            <p class="mb-15 text-muted">
              The company Telegram (the icon at the top of every customer page and the signature line of every email), email (SMTP) and the Telegram bots are set in
              <router-link to="/admin/integrations" class="text-primary fw-semibold">Admin › Integrations</router-link>.
            </p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between">
            <button class="rounded-1 border-1 btn btn-outline-primary " type="submit">
              Save Profile
            </button>
          </div>
        </div>
      </Form>
      <Form class="mt-30 pt-25 border-top" @submit="onPasswordSubmit" :validation-schema="passwordSchema"
        v-slot="{ errors }">
        <div class="mb-20">
          <h6 class="text-black fw-semibold mb-5">Change Password</h6>
          <p class="mb-0 text-muted">
            Enter your current password before setting a new one. If you cannot access your account, sign out and use
            Forgot Password on the login screen.
          </p>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Current Password
              </label>
              <Field name="old_password" v-slot="{ field }">
                <input v-bind="field" type="password" autocomplete="current-password"
                  class="form-control shadow-none rounded-0 text-black" placeholder="Current password" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.old_password }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                New Password
              </label>
              <Field name="new_password" v-slot="{ field }">
                <input v-bind="field" type="password" autocomplete="new-password"
                  class="form-control shadow-none rounded-0 text-black" placeholder="New password" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.new_password }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Confirm New Password
              </label>
              <Field name="confirm_password" v-slot="{ field }">
                <input v-bind="field" type="password" autocomplete="new-password"
                  class="form-control shadow-none rounded-0 text-black" placeholder="Confirm new password" />
              </Field>
              <span class="text-warning font-bold inline text-nowrap">{{ errors.confirm_password }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between">
            <button class="rounded-1 border-1 btn btn-outline-primary" type="submit">
              Change Password
            </button>
          </div>
        </div>
      </Form>
    </div>
  </div>

</template>

<script setup>

import { storeToRefs } from "pinia"
import { Form, Field } from 'vee-validate';
import * as Yup from 'yup';
import { ref } from "vue";
import { useAccountStore } from "@/stores";
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore)
const selectedCountry = ref(user.value.country)
const selectedRegion = ref(user.value.city)
const adminValidationSchema = {
  email: Yup.string().required('Email is required').email("Invalid email format"),
  user_name: Yup.string().required('User Name is required'),
  name: Yup.string().required('Full Name is required'),
  address: Yup.string().required('Address is required'),
  country: Yup.string().required('Country is required'),
  city: Yup.string().required('Region is required'),
}
const schema = user.value?.role === 'admin' ? Yup.object().shape(adminValidationSchema) : Yup.object().shape({
  email: Yup.string().required('Email is required').email("Invalid email format"),
  user_name: Yup.string().required('User Name is required'),
  name: Yup.string().required('Full Name is required'),
  address: Yup.string().required('Address is required'),
  country: Yup.string().required('Country is required'),
  city: Yup.string().required('Region is required'),
});

const passwordSchema = Yup.object().shape({
  old_password: Yup.string().required('Current password is required'),
  new_password: Yup.string().required('New password is required').min(8, 'Password must be at least 8 characters'),
  confirm_password: Yup.string().required('Confirm password is required').oneOf([Yup.ref('new_password')], 'Passwords do not match'),
});



async function onSubmit(values) {
  const profileValues = { ...values };
  delete profileValues.old_password;
  delete profileValues.new_password;
  delete profileValues.password;
  delete profileValues.confirm_password;
  await accountStore.updateAccountAll(profileValues);
  // await accountStore.udpateAccount(values);
}

async function onPasswordSubmit(values) {
  await accountStore.updatePassword(values.old_password, values.new_password);
}
// function deleteAccount() {
//   alert('delete')
// }
</script>
